import { cn } from "@/lib/utils"
import CreateTheme from "./create-theme/CreateTheme"
import { useEffect, useState } from "react"
import TemplateSelection from "./template-flow/TemplateSelection"
import { useCreateTemplateImageForNonEditable, useGetTemplateDetails } from "./api/templates"
// import TemplateResult from "./template-result/TemplateResult"
import { Template } from "./types"
import { useNavigate, useSearchParams } from "react-router-dom"

export type CreateThemeSteps = "create-theme" | "select-template" | "template-form"

const CreateThemeView = () => {

  const [searchParams, setSearchParams] = useSearchParams()

  const [step, setStep] = useState<CreateThemeSteps>(searchParams.get("opt") ? searchParams.get("opt") as CreateThemeSteps : "create-theme")

  useEffect(() => {
    if (searchParams.get("opt") !== null) {
      setStep(searchParams.get("opt") as CreateThemeSteps)
    }
  }, [searchParams])

  const [template, setTemplate] = useState<Template | undefined>(undefined);

  const { templateDetailsData } = useGetTemplateDetails(template?.template_id)

  const { status } = useCreateTemplateImageForNonEditable()

  const navigate = useNavigate()

  useEffect(() => {
    if (status === "success" && templateDetailsData) {
      navigate(`/home?curr=result&theme=${templateDetailsData.data.event_id}`)
    }
  }, [status, templateDetailsData])

  useEffect(() => {
    if (templateDetailsData) {
      setStep('template-form')
    }
  }, [templateDetailsData])

  const setStepHandler = (id: CreateThemeSteps) => {
    setSearchParams({opt: "select-template"})
    setStep(id);
  }

  return (
    <div className="mt-[5vh] w-full h-[95vh] p-5 md:p-7 md:pt-4 2xl:p-14 overflow-auto flex flex-col gap-4 xl:gap-8 ">
      <div className="w-full sm:w-[calc(100%-4rem)] lg:w-[55rem] xl:w-[60rem] mx-auto space-y-3">
        <div className={cn("w-full flex flex-col gap-2")} id="chat-container">
          {step === "create-theme" &&
            <CreateTheme setStep={setStepHandler} />
          }

          {step === "select-template" &&
            <TemplateSelection setTemplate={setTemplate} setStep={setStepHandler} />
          }

        </div>
      </div>
    </div>
  )
}

export default CreateThemeView
